import styles from './otp-step.module.scss';
import { IOTPStepProps } from '../../types/OTP';
import { OTP } from './OTP';
import { ResendOTP } from './ResendOTP';

const localizedTexts = {
  en: {
    resendText: 'Resend code in',
    resendBtnText: 'Re-send',
  },
  ar: {
    resendText: 'إعادة إرسال الرمز بعد',
    resendBtnText: 'إعادة إرسال',
  },
}

export const OTPStep = (props: IOTPStepProps) => {
  const {
    lang = 'en',
    otp,
    setOtp,
    onResendOTP,
    onValid,
    resendText = localizedTexts[lang].resendText,
    resendBtnText = localizedTexts[lang].resendBtnText,
    resendTimer = 60,
    otpResetTimerKey,
    error,
    customStyle,
    length = 4,
    loading
  } = props;

  const onComplete = (otp: any) => {
    setOtp(otp);
  };

  return (
    <div className={styles['container']}>
      <div>
        <OTP
          setOtp={setOtp}
          length={length}
          otpValue={otp}
          onComplete={onComplete}
          customStyle={customStyle?.input}
          onValid={onValid}
          isError={!!error}
          loading={loading}
        />
      </div>

      {error && <div className={styles['error-message']}>{error}</div>}

      {onResendOTP && (
        <ResendOTP
          loading={loading}
          lang={lang}
          time={resendTimer}
          onSubmit={onResendOTP}
          customStyle={customStyle}
          text={resendText}
          resendBtnText={resendBtnText}
          otpResetTimerKey={otpResetTimerKey}
          setOtp={setOtp}
        />
      )}
    </div>
  );
};
